module.exports = __webpack_public_path__ + "img/jiagourus.11d6f16b.png";